<template>

    <div class="holder">

        <!--<button @click="createIntent" class=" hang btn btn-sm btn-gradient-primary float-right"> +  New-->
        <!--Group-->
        <!--</button>-->

        <Loader v-if="loading" :show-full="false" loading-text="Loading"/>

        <div class="search-area">
            <div class="input-group">
                <div class="input-group-prepend ">
                    <i class="input-group-text border-0 mdi mdi-magnify"></i>
                </div>
                <input type="text" class="form-control "
                       placeholder="Search Intents" v-model="query"
                       model-event="change">
            </div>
        </div>
        <p style="margin-top: 20px" class="p-2" v-if="intents.length<1">No intents yet, add an intent to this group to
            get
            started</p>
        <div class="intents">
            <div :key="intent.key" v-for="intent in filteredList" class="intent"
                 v-bind:class="{selected:intent.key===selected_intent.key}"
                >

                <input v-model="selected" id="checkers" type="checkbox"
                       :value="intent.key"
                       class="form-check-input">
                <div  @click="selectIntent(intent)" class="utr">{{intent.name}}</div>


                <div @click="deleteIntent(intent.key,intent.name) " class="ic"><i
                        class="mdi mdi-delete mdi-16px"></i></div>
            </div>
        </div>
    </div>

</template>

<script>
    import Layout from '../../components/Layout';
    import Loader from "../../components/Loader/Loader";

    import {userService} from '../../services/user.service';

    export default {
        name: "Intent",
        components: {Layout, Loader},
        props: ["group_id"],
        data() {
            return {

                loading: true,

                intents: [],
                groups: [],
                filtered: [],
                selected: [],

                selected_intent: "",
                query: "",


            }
        },
        computed: {

            filteredList() {
                return this.intents.filter(intent => {
                    return intent.name.toLowerCase().includes(this.query.toLowerCase())
                })
            },


        },
        methods: {
            selectIntent(intent) {
                this.selected_intent = intent;
                this.$emit("onIntentSelect", intent)
            },
            async deleteIntent(key, name) {
                let yesDelete = window.confirm(
                    `Are you sure you want to delete ${name}?`
                );
                if (yesDelete) {
                    this.loading = true;
                    await userService.deleteIntent(key)
                        .then((res) => {
                            this.loading = false;
                            this.selectIntent({});
                            this.intents = this.intents.filter(function (obj) {
                                return obj.key !== key;
                            });
                            this.$toastr.success("Success", "Deleted intent!", {timeOut: 5000});

                        }).catch((error) => {
                            this.loading = false;
                            this.$toastr.error(error.message, "Error deleting intents!", {timeOut: 5000});

                        });
                }
            },

        },
        async created() {
            // if (this.group_id) {
            //     console.log(this.group_id)
            //     return this.intents = res.filter(intent => {
            //
            //         return intent.group_id === this.group_id;
            //
            //     });
            // }

            await userService.getIntents(this.group_id? this.group_id:null)
                .then((res) => {

                    this.loading = false;

                        this.intents = res;



                    console.log(this.intents);
                }).catch((error) => {
                    this.loading = false;
                    this.$toastr.error(error.message, "Error loading intent!", {timeOut: 5000});

                });

        }
    }
</script>

<style scoped>
    .holder {
        height: 100%;
        width: 100%;
        margin-right: auto;
        margin-left: auto;
    }

    .search-area {
        margin-top: 20px;
    }

    .bulk-actions {
        margin-top: 10px;
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;
    }

    .intents {
        width: 100%;
        margin: auto;
        margin-top: 20px;
        left: 0;
        right: 0;
        height: 58vh;
        box-sizing: border-box;
        overflow: auto;
        overflow-y: scroll;
    }

    .intent {
        margin-top: 10px;
        margin-bottom: 10px;
        cursor: grab;
        box-sizing: border-box;
        padding: 10px 8px;
        padding-left: 26px;
        display: flex;
        position: relative;

    }

    .intent:hover {
        color: #353cd6;
        background: unset;
        font-weight: bold;
    }

    .intent:hover #checkers {
        display: block;
    }

    .intent .utr {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        width: 95%;
        padding: 8px 2px;


    }

    .intent.selected {
        font-weight: bold;
        color: #353cd6 !important;
    }

    .intent .linker {
        color: #343434;
    }

    .intent .ic {
        float: right;
        position: absolute;
        right: 5px;
    }

    a:hover {
        color: #0056b3 !important;
        text-decoration: underline;
    }

    input[type=checkbox]:checked {
        display: block;
    }

    input[type=checkbox]:not(:checked) {
        display: none;
    }


</style>
